<template>
  <div :class="['flex flex-col w-full', cl]">
    <label v-if="hasLabel" :for="$attrs.label" :class="['mb-1 hidden lg:block', labelFont]">
      {{ label }}
    </label>
    <div class="relative">
      <input
        :type="isVisible ? 'text' : 'password'"
        :id="$attrs.label"
        v-bind="$attrs"
        v-on="inputListeners"
        v-bind:value="value"
        ref="input"
        :placeholder="label"
        autocomplete="off"
        spellcheck="false"
        required
        :class="[
          'input password placeholder-secondary-dark placeholder-opacity-100 lg:placeholder-opacity-0 pr-12',
          size,
          inverted ? 'bg-white' : '',
        ]"
      />
      <span
        v-if="value.length > 0"
        @click="isVisible = !isVisible"
        v-tooltip.top="{content: tooltipText}"
        class="flex items-center select-none opacity-75 h-full absolute inset-y-0 right-0 mr-2"
      >
        <BaseIcon :icon="!isVisible ? 'password-hide' : 'password-show'" />
      </span>
    </div>
    <div v-if="$slots.append" class="flex justify-end pt-2">
      <slot name="append"></slot>
    </div>
  </div>
</template>

<script>
import BaseIcon from './_base-icon.vue'
import {inputStyle} from '@/state/helpers/mixins.js'

export default {
  mixins: [inputStyle],
  inheritAttrs: false,
  components: {BaseIcon},
  props: {
    value: {
      type: String,
      default: '',
    },
    focused: {
      type: Boolean,
      default: false,
    },
    inverted: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseIcon,
  },
  model: {
    event: 'update',
  },
  data() {
    return {
      isVisible: false,
    }
  },
  watch: {
    focused: {
      immediate: true,
      handler(n, o) {
        if (n) {
          this.$nextTick(() => this.$refs.input.focus())
        }
      },
    },
  },
  computed: {
    hasLabel() {
      return typeof this.$attrs.label !== 'undefined'
    },
    label() {
      return typeof this.$attrs.label === 'undefined'
        ? ''
        : this.$t(`mygwf.components.Label.${this.$attrs.label}`)
    },
    tooltipText() {
      return !this.isVisible
        ? this.$t(`mygwf.components.InputPassword.show_password`)
        : this.$t(`mygwf.components.InputPassword.hide_password`)
    },
    inputListeners: function () {
      var vm = this
      return Object.assign({}, this.$listeners, {
        input: function (event) {
          vm.$emit('update', event.target.value)
        },
      })
    },
  },
}
</script>
<style scoped>
.input {
  @apply bg-secondary-light appearance-none inline-block w-full border rounded-none leading-normal;
}

.input:focus {
  @apply outline-none border-primary-light bg-white;
}

.input:disabled {
  @apply opacity-75 cursor-default;
}

/* Last pass icon fix */
.input.password {
  background-position: 93% 50% !important;
}
</style>
